import { Icon, Tooltip } from 'antd';
import React from 'react';

type Props = {
    tooltip: string;
};

export default function SectionTooltip({ tooltip }: Props) {
    return (
        <div className="report-element-info">
            <Tooltip
                placement="left"
                title={<div dangerouslySetInnerHTML={{ __html: tooltip }} />}
            >
                <Icon
                    type="info-circle"
                    theme="filled"
                    className="info-icon"
                />
            </Tooltip>
        </div>
    );
}
